import Vue from 'vue';
import accountService from './';

const success = (context, response, fromOnboarding, pwdChanged) => {
  
  if (response.verification
    && response.verification.airlock
    && response.verification.airlock.status
    && response.verification.airlock.status != 2) {
    if (fromOnboarding) {
      context.user.onboarding_step = 6;
    } else if (!pwdChanged) {
      context.activeStep = 4;
    }
    toastr.error(response.verification.airlock.user_message);
  } else if (fromOnboarding) {
    accountService.createNewAirbnbAccount(context, context.airbnbAccount, context.user);
  } else if (pwdChanged) {
    const data = {
      randomDeviceId: context.randomDeviceId,
      editAirbnbAccountPwd: context.editAirbnbAccountPwd,
      airbnbAccount: context.airbnbAccount,
    };
    accountService.editAirbnbAccountPwd(context, data);
  } else {
    accountService.addAirbnbAccount(context, context.abAccount, context.users);
  }
};

const failed = (context, error, fromOnboarding = false, pwdChanged) => {
  if (fromOnboarding) {
    context.user.onboarding_step = 7;
  } else if (!pwdChanged) {
    context.activeStep = 4;
  }
  context.showToasterError(error);
};

export default (context, data, generalData, randomDeviceId, verificationCode, fromOnboarding, pwdChanged = false) => {
  const dataSend = {
    methodData: data,
    generalData,
    randomDeviceId,
    verificationCode,
  };
  return Vue.$http.post('/check-airbnb-verification-code', dataSend)
    .then((response) => {
      if (response && response.status === 200) {
        success(context, response.data, fromOnboarding, pwdChanged);
      } else {
        failed(context, response, fromOnboarding, pwdChanged);
      }
    }).catch((error) => {
      failed(context, error, fromOnboarding, pwdChanged);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/account/checkAirbnbVerificationCode.js